import type { ChainInfo } from '@portkey/services';
import { ChainId } from '@portkey/types';
import { did } from '../utils';
import { useCallback, useMemo, useState } from 'react';
import { useEffectOnce } from 'react-use';
import { useIsMainnet } from './common';

type ChainMapType = { [key in ChainId]: ChainInfo };

export const getChainInfo = async (originChainId?: ChainId) => {
  const chainList = await did.services.getChainsInfo();
  const chainMap = {} as ChainMapType;
  chainList.forEach((chain) => (chainMap[chain.chainId as ChainId] = chain));
  if (originChainId) return chainMap[originChainId];
  throw Error(`The current network does not support the ChainId '${originChainId}'`);
};

export const getChain = async (chainId: ChainId) => {
  const info = did.didWallet.chainsInfo?.[chainId];
  if (info) return info;
  return getChainInfo(chainId);
};

export const useCurrentChainList = (): {
  chainList: ChainInfo[];
  getChainList: () => Promise<any>;
} => {
  const [chainList, setChainList] = useState<ChainInfo[]>([]);

  const getChainList = useCallback(async () => {
    try {
      const chainList = await did.services.getChainsInfo();
      console.log('chainList', chainList);
      setChainList(chainList);
    } catch (error) {
      console.warn('getChainList error', error);
    }
  }, []);

  useEffectOnce(() => {
    getChainList();
  });

  return { chainList, getChainList };
};

export const useDAppChainId = () => {
  const isMainnet = useIsMainnet();

  return useMemo<ChainId>(() => (isMainnet ? 'tDVV' : 'tDVW'), [isMainnet]);
};
